import { render, staticRenderFns } from "./searchPanel.vue?vue&type=template&id=054738c0&scoped=true&"
import script from "./searchPanel.vue?vue&type=script&lang=js&"
export * from "./searchPanel.vue?vue&type=script&lang=js&"
import style0 from "./searchPanel.vue?vue&type=style&index=0&id=054738c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054738c0",
  null
  
)

export default component.exports